module.exports = __webpack_public_path__ + "img/comercio-microilustracion.1071ee02.svg";